<template>
  <div id="contact">

    <div v-if="$route.params[0]">
        <div class="container columns is-m-auto">
          <div class="column is-12 has-text-centered alert">Votre demande de contact est envoyé. Vous recevrez une réponse dans les prochains jours.</div>
        </div>
    </div>

    <section class="map">
      <div class="columns">
        <div class="column is-4">
          <div class="columns is-multiline">
            <div class="column is-6 infos">
              <h2 class="title column has-text-right">contact</h2>
              <figure class="image is-3by1 column is-12"></figure>
            </div>
            <div class="column is-12">
              <div class="column is-9 is-offset-2" v-if="join">
                <rich-text :elements="join.document.content" :is-root="true"></rich-text>
              </div>
              <div class="column is-9 is-offset-2" v-if="address">
                <rich-text :elements="address.document.content" :is-root="true"></rich-text>

                <a target="_blank" class="child text column google-link" href="https://www.google.com/maps/place/Assurances+Guemas+et+Associ%C3%A9s/@47.0834534,-1.2860287,17.53z/data=!4m5!3m4!1s0x480675a1e856dd7b:0x5b1bfcec5840f1c7!8m2!3d47.0834242!4d-1.2847009">Voir sur Google Maps</a>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-8" id="mapbox"></div>
      </div>
    </section>

    <section class="form">
      <div id="form-contact"></div>
     <div class="column is-9 is-m-auto has-text-centered terms" v-if="mentions">
       <rich-text :elements="mentions.document.content" :is-root="true"></rich-text>
      </div>
    </section>
  </div>
</template>

<script>
import api from '@/services/api';
import RichText from '@/components/RichText.vue';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';

export default {
  name: 'contact',
  components: {
    RichText,
  },
  data() {
    return {
      address: null,
      join: null,
      mentions: null,
    };
  },
  async created() {
    await this.fetchData();
  },
  mounted() {
    document.querySelector('#form-contact').innerHTML = document.querySelector('#form').innerHTML;
    this.fetchMapBox();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    async fetchData() {
      this.address = await api.getInfo('560d21bd-57f3-441b-89cb-4ecef5b2bb11');
      this.join = await api.getInfo('812f5241-d411-45af-8edb-ca2f6d314971');
      this.mentions = await api.getInfo('1b3faaf4-f23d-426f-843c-f7e5eec829b6');
    },
    fetchMapBox() {
      mapboxgl.accessToken = 'pk.eyJ1IjoiZ3VlbWFzYXNzb2NpZXMiLCJhIjoiY2p0cHUzYXQ2MDdvMTN5czdrcXVsbGgxdSJ9.tZcECWUVqnzCeWmeWZ57Iw';
      const map = new mapboxgl.Map({
        container: 'mapbox',
        style: 'mapbox://styles/guemasassocies/cjtpuattm2tm51fqq64povsk1',
        zoom: 16,
        center: [-1.2850, 47.0828],
      });
      const marker = require('../assets/icons/marker.png'); // eslint-disable-line

      map.on('load', () => {
        /* Image: An image is loaded and added to the map. */
        map.loadImage(marker, (error, image) => {
          if (error) throw error;
          map.addImage('custom-marker', image);
          /* Style layer: A style layer ties together the source and image and specifies how they are displayed on the map. */
          map.addLayer({
            id: 'markers',
            type: 'symbol',
            /* Source: A data source specifies the geographic coordinate where the image marker gets placed. */
            source: {
              type: 'geojson',
              data: {
                type: 'FeatureCollection',
                features: [
                  {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                      type: 'Point',
                      coordinates: [-1.284701, 47.083297],
                    },
                  },
                ],
              },
            },
            layout: {
              'icon-image': 'custom-marker',
            },
          });
        });
      });
    },
  },
};
</script>

<style lang='sass'>
  .hero
    margin-bottom: 5rem !important

  #contact
    .alert
      margin-bottom: 2rem
      background: #ecf1f4
      border-radius: 4px

    .infos
      padding: 0
      height: 100%
      figure
        padding: 0
        margin: 1rem 0 3rem 0
        height: 4px
        width: 100%
        background-color: #fe3904
    .map .columns .column.is-4
      padding: 0
    .map
      position: relative
      margin-bottom: 0 !important
      padding: 0 0 10rem 0
      z-index: 1
      &::after
        position: absolute
        content: ''
        height: 10%
        width: 100%
        bottom: 0
        left: 0
        background-color: #ecf1f4
        z-index: -1
      .google-link
        color: #0e6faa
      #mapbox
        height: 650px
        canvas
          &:focus, &:active
            text-decoration:none
            outline: none

    .form
      // padding: 0 0 10rem 0
      margin: 0 auto !important
      background-color: #ecf1f4
      p
        margin: 0 0 2rem 0 !important
      .column
        margin: 1rem 0
      input, textarea, select
        border: 0
        border-radius: 0
        box-shadow: none
      .select::after
        border-color: #fe3904
      input::placeholder, textarea::placeholder, select.placeholder
        color: #aaaaaa !important
        font-style: italic
      button
        margin: 5rem auto 6rem auto !important
        border: 0
        border-radius: 0
        box-shadow: none
        color: #ffffff
        background-color: #fe3904
      .terms
        max-width: 600px
        padding: 0 0 4rem 0
        div, span
          display: inline
</style>
